import {email as emailRegex} from './regex';

export const email = value =>
  !emailRegex.test(value) ? 'Invalid email address' : undefined;

export const required = value =>
  value || typeof value === 'number' || typeof value === 'boolean'
    ? undefined
    : 'Required';

export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const number = count => value => {
  const regex = new RegExp(
    '^[0-9]' +
    (typeof count === 'number' && count > 0 ? `{${count}}` : '+') +
    '$',
    'g'
  );
  const res = !regex.test(value) ? 'Invalid numbers' : undefined;
  return res;
};

export const password = value => {
  if (required(value)) return required(value);

  if (
    typeof value === 'string' &&
    value.length >= 8 &&
    /[a-z]/.test(value) &&
    /[A-Z]/.test(value) &&
    /\d/.test(value) &&
    /[!@#$+%^&*(),.?":{}|<>]/.test(value)
  ) {
    return undefined;
  }
  return 'Invalid password';
};

